import React from 'react';
import PropTypes from 'prop-types';
import { domToReact } from 'html-react-parser';

import { classNames } from 'wp/plugins/cdm-customizations/blocks/qlsinglecta/Constants';
import { classNames as classCtaBlock } from 'wp/plugins/cdm-customizations/blocks/qlctablock/Constants';
import ArticleSingleCta from '../../../../../components/Molecules/ArticleSingleCta';
import findDomElement, { findDomElementFilterFn, findDomElements } from '../../../../findDomElement';
import { testAttributes, wpQlsinglectaClass } from './Constants';
import { Tags } from '../toTypography/Constants'

export const getCleanFirstChildData = (element) => element?.firstChild?.data?.replace(/[\n]?/g, '')?.trim();

const filterByClassName = (className) => (element) => element?.attribs?.class?.includes(className);

const toSingleCTA = ( parserData ) => 
{
    const { articleId, parserOptions: {replaceFn} } = parserData;
    const Wrapper = ({name = '', type = '', attribs = { href: '' }, children = null}) =>
    {
        if ( type !== 'tag' ) return null;
        if (!name || name !== 'aside') return null;
        if (!attribs?.class || (!attribs?.class.includes(wpQlsinglectaClass) && !attribs?.class.includes('ql-cta-block'))) return null;

        const props = {
            title: '',
            buttonLabel: '',
            description: '',
            icon: '',
        }

        const foundIcon = findDomElement({ element: children.filter(child => child.type === "tag")?.at(0), targetName: 'img' })        
        const foundSingleCtaTitle = findDomElementFilterFn({ 
            element: children.filter(child => child.type === "tag")?.at(0), 
            filterFn: filterByClassName(classNames.CTA_TITLE) 
        })
        const foundCtaBlockTitle = findDomElementFilterFn({ 
            element: children.filter(child => child.type === "tag")?.at(0), 
            filterFn: filterByClassName(classCtaBlock.CTA_TITLE) 
        })

        const foundDescription = findDomElement({ element: children.filter(child => child.type === "tag")?.at(0), targetName: 'p' })
        const foundAnchor = findDomElement({ element: children.filter(child => child.type === "tag")?.at(0), targetName: 'a' })

        if (foundIcon) 
        {
            props.icon = foundIcon.attribs.src;
        }

        if (foundSingleCtaTitle) 
        {
            props.title = getCleanFirstChildData(foundSingleCtaTitle);
            props.headline = Tags.find(item => item.tag === foundSingleCtaTitle.name);
        }

        if (foundDescription) 
        {
            props.description = domToReact([foundDescription], replaceFn());
        }

        if (foundAnchor) 
        {
            const svg = findDomElement({ element: foundAnchor, targetName: 'svg' })
            
            props.href = foundAnchor.attribs.href;
            props.buttonText = foundAnchor?.children?.[0].children?.[0].data;
            props.buttonIcon = svg ? domToReact([svg]) : undefined;
            if (foundAnchor.attribs?.target)
            {
                props.buttonAttributes = {
                    target: foundAnchor.attribs.target
                };
            }
        }

        if (foundCtaBlockTitle) 
        {
            props.title = getCleanFirstChildData(foundCtaBlockTitle);
            props.headline = Tags.find(item => item.tag === foundCtaBlockTitle.name);
            props.description = domToReact(foundDescription.children);
            props.type = 'new';

            const anchors = findDomElements({ 
                element: children.filter(child => child.type === "tag")?.at(0), targetName: 'a' 
            })
            props.buttons = anchors.map(anchor => 
            {
                const svg = findDomElement({ element: anchor, targetName: 'svg' })
                return {
                    href: anchor.attribs.href,
                    buttonText: anchor?.children?.[0].children?.[0].data,
                    buttonIcon: svg ? domToReact([svg]) : undefined,
                    buttonClasses: anchor.attribs.class,
                    buttonAttributes: {
                        target: anchor.attribs.target
                    }
                }
            })
        }
        
        return <div data-testid={testAttributes.SINGLE_CTA_CONTAINER}>
            <ArticleSingleCta {...props} articleId={articleId} />
        </div>;
    }

    Wrapper.propTypes = {
        name: PropTypes.oneOf(['h3', 'a']),
        type: PropTypes.oneOf(['tag']),
        attribs: PropTypes.shape({
            class: PropTypes.string
        }),
        children: PropTypes.node,
    }

    return Wrapper;
}

export default toSingleCTA;